<template>
  <CommonPagesMainContainer>
    <CommonPagesLogo></CommonPagesLogo>
    <div class="uk-visible@l">
      <CommonPagesGreeting></CommonPagesGreeting>
      <CommonPagesFormCard>
        <CommonPagesForm
          header="Пожалуйста, авторизуйтесь:"
          :message="errorMessage"
          @keyup.enter.native="submitHandler"
        >
          <CommonPagesField
            v-model="email"
            id="login"
            :is-error="$v.email.$error"
            :isDisabled="isDisabled"
            label="Логин"
            name="login"
            autocomplete
          />
          <CommonPagesField
            v-model="password"
            id="password"
            :is-error="$v.password.$error"
            :isDisabled="isDisabled"
            label="Пароль"
            name="password"
            :type="isShowPassword ? 'text' : 'password'"
            autocomplete
            class="password-input-block"
            @animationstart.native="checkAnimation"
          >
            <template #password-icon>
              <button
                type="button"
                class="password-button"
                @click="isShowPassword = !isShowPassword"
              >
                <img
                  :src="
                    isShowPassword
                      ? require('@/assets/images/eye.svg')
                      : require('@/assets/images/eye-off.svg')
                  "
                  alt="eye"
                />
              </button>
            </template>
          </CommonPagesField>
          <LoginPasswordRestoreButton v-if="!isDemo" />
          <CommonPagesFormButton
            name="Войти в демо-режим"
            :isDisabled="isDisabled"
            class="uk-width-1-2"
            @click="submitHandler"
          />
          <div :class="{'captcha-wrapper': !validCaptcha}">
            <vue-recaptcha
              ref="recaptcha"
              size="invisible"
              :sitekey="sitekey"
              @verify="onVerify"
              @expired="onCaptchaExpired"
            />
          </div>
        </CommonPagesForm>
      </CommonPagesFormCard>
    </div>
    <h3
      class="uk-hidden@l uk-animation-slide-bottom-medium uk-text-center uk-flex uk-flex-center uk-light uk-width-1-1"
    >
      На данный момент мобильная версия недоступна
    </h3>
  </CommonPagesMainContainer>
</template>

<script>
import CommonPagesMainContainer from '@/components/CommonPagesMainContainer'
import CommonPagesLogo from '@/components/CommonPagesLogo'
import CommonPagesGreeting from '@/components/CommonPagesGreeting'
import CommonPagesFormCard from '@/components/CommonPagesFormCard'
import CommonPagesForm from '@/components/CommonPagesForm'
import CommonPagesField from '@/components/CommonPagesField'
import CommonPagesFormButton from '@/components/CommonPagesFormButton'
import LoginPasswordRestoreButton from '@/views/pages/login/PasswordRestoreButton'

import {required, email} from 'vuelidate/lib/validators'

import {mapActions} from 'vuex'
import config from '@/config'

export default {
  name: 'Login',
  components: {
    LoginPasswordRestoreButton,
    CommonPagesFormButton,
    CommonPagesField,
    CommonPagesForm,
    CommonPagesFormCard,
    CommonPagesGreeting,
    CommonPagesLogo,
    CommonPagesMainContainer
  },
  data: () => ({
    email: 'demo@bsb.by',
    password: 'nrN6DpMwmV',
    errorMessage: '',
    validCaptcha: false,
    isDisabled: false,
    tokenCaptcha: null,
    sitekey: config.RECAPTCHA_PUBLIC_KEY,
    isShowPassword: false,
    isDemo: true
  }),
  methods: {
    ...mapActions({
      login: 'auth/LOGIN'
    }),
    submitHandler() {
      this.$v.$touch()

      if (!this.$v.$error) {
        let user = {
          email: this.email,
          password: this.password
        }

        if (this.validCaptcha) {
          this.$refs.recaptcha.execute()
          return
        }

        this.login(user)
          .then(() => {
            this.$router.push('/')
          })
          .catch(err => {
            this.errorMessage = this.getErrorMessage(err)
          })
      } else {
        this.errorMessage = 'Не заполнены обязательные поля'
        if (!this.$v.email.email) this.errorMessage = 'E-mail должен быть валидным'
      }
    },
    getErrorMessage(err) {
      try {
        const counter = err.response.data.counter
        if (!counter) {
          return 'Неверный логин или пароль'
        }
        const tmp = Math.abs(5 - counter)
        if (counter === 5) {
          this.isDisabled = true
          this.timeError(tmp + 1)
          return 'Неверный логин или пароль. Повторите попытку через 1 минуту'
        } else if (counter > 5) {
          this.isDisabled = true
          this.timeError(tmp + 1)
          return `Исчерпан лимит попыток! Повторите попытку через ${tmp + 1} минуту`
        } else {
          this.password = ''
          return `Неверный логин или пароль. Осталось ${tmp} попытки`
        }
      } catch {
        this.clearError()
        return `Неверный логин или пароль`
      }
    },
    clearError() {
      this.email = ''
      this.password = ''
      this.errorMessage = ''
      this.$v.$reset()
    },
    checkAnimation(e) {
      if (e.animationName == 'onAutoFillStart') {
        this.login()
      }
    },
    timeError(time) {
      setTimeout(() => {
        this.clearError()
        this.isDisabled = false
        this.validCaptcha = true
      }, time * 60000)
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
      this.validCaptcha = false
    },
    async onVerify(recaptchaToken) {
      this.tokenCaptcha = await recaptchaToken

      let user = {
        email: this.email,
        password: this.password,
        reCaptchaToken: this.tokenCaptcha ? this.tokenCaptcha : null
      }

      this.login(user)
        .then(() => {
          this.$router.push('/')
        })
        .catch(err => {
          this.errorMessage = this.getErrorMessage(err)
        })
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    }
  }
}
</script>

<style scoped>
:-webkit-autofill {
  animation-name: onAutoFillStart;
}

:not(:-webkit-autofill) {
  animation-name: onAutoFillCancel;
}

@keyframes onAutoFillStart {
  from {
  }
  to {
  }
}

@keyframes onAutoFillCancel {
  from {
  }
  to {
  }
}

.captcha-wrapper {
  display: none;
}
</style>
